export default __webpack_public_path__ + "static/media/maintenanceBackgroundMB.83c68296.png";